export const timeouts = {
  waterfallstart: 1000,
  waterfallend: 10000,
  googleImaInit: 20000,
  yartbstart: 3000,
  vpaidstart: 5000,
  loadAd: 500,
  initScript: 3000,
  checkPlayback: 5000,
  limitedDuration: 15000,
};

export const hlsInitParams = {
  maxBufferLength: 1,
  maxBufferSize: 0.5,
};
